import React from 'react';
import { 
  HelpCircle, 
  Calendar, 
  Clock, 
  Briefcase, 
  Flag, 
  Calculator, 
  Check, 
  FileText 
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Calendar,
      title: 'Рабочие дни',
      description: 'Для точного планирования рабочих задач используйте опцию "Учитывать только рабочие дни".'
    },
    {
      icon: Clock,
      title: 'Перенос праздников',
      description: 'В России выходные часто переносятся, если праздник выпадает на субботу или воскресенье.'
    },
    {
      icon: Briefcase,
      title: 'Производственный календарь',
      description: 'Официальный производственный календарь публикуется Правительством РФ в конце года.'
    },
    {
      icon: Flag,
      title: 'Региональные праздники',
      description: 'В разных регионах России могут быть дополнительные праздничные дни.'
    },
    {
      icon: Calculator,
      title: 'Расчет сроков',
      description: 'При планировании проектов лучше добавлять временной запас на случай непредвиденных ситуаций.'
    },
    {
      icon: Check,
      title: 'Точные даты',
      description: 'Для юридических документов указывайте точную дату без сокращений.'
    },
    {
      icon: FileText,
      title: 'Экспорт данных',
      description: 'Используйте функцию экспорта для сохранения результатов расчета в документах.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-cyan-500" />
        Полезные советы
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-cyan-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Calendar className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Производственный календарь
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Актуальный производственный календарь России с официальными праздниками и переносами выходных дней.
            </p>
            <a 
              href="https://www.consultant.ru/law/ref/calendar/proizvodstvennye/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors text-center"
            >
              Открыть календарь
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;